import { render } from "./InspectionThanks.vue?vue&type=template&id=f771fc08"
import script from "./InspectionThanks.vue?vue&type=script&lang=js"
export * from "./InspectionThanks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__